import { ListItem as ListItemMUI, List } from '@material-ui/core';

import styled from 'styled-components';

import { mediaQueries } from '../../../../libs';

export const ListItem = styled(ListItemMUI)`
  padding: 5px !important;
  width: fit-content !important;
`;

export const Link = styled.a`
  color: inherit;
  display: flex;
  align-items: center;
  font-size: 13px;
  min-width: 80%;
  text-transform: capitalize;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: ${mediaQueries.smDefault}px) {
    height: 30px;
  }
`;

export const ListStyled = styled(List)`
  padding: 0 !important;
`;
